
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import HomeScreen from "./Pages/HomeScreen";
import AboutScreen from "./Pages/AboutScreen";
import ShopScreen from "./Pages/ShopScreen";
import CartScreen from "./Pages/CartScreen";
import ProfileScreen from "./Pages/ProfileScreen";
import OrdersScreen from "./Pages/OrdersScreen";
import SingleTour from "./Pages/SingleTour";
import ContactUsScreen from "./Pages/ContactUsScreen";
import TopNavigation from "./components/Top/TopNavigation";
import MainFooter from "./components/Footer/MainFooter";
import PolicyScreen from "./Pages/PolicyScreen";
import TermsnConditions from "./Pages/TermsnConditions";
import CheckOut from "./Pages/CheckOut";

function App() {
  return (
    <>
      <Router>
        <div className="main-container">
          <TopNavigation />
          <Routes>
              <Route path="/" element={<HomeScreen />}/>  
              <Route path="/about" element={<AboutScreen />}/>
              <Route path="/contact-us" element={<ContactUsScreen />}/>  
              <Route path="/shop" element={<ShopScreen />}/> 
              <Route path="/tour/:id" element={<SingleTour />}/>  
              <Route path="/orders/" element={<OrdersScreen />}/>  
              <Route path="/profile/" element={<ProfileScreen />}/>  
              <Route path="/policy/" element={<PolicyScreen />}/>  
              <Route path="/terms-and-conditions/" element={<TermsnConditions />}/>  
              <Route path="/cart/" element={<CartScreen />}/> 
              <Route path="/checkout/" element={<CheckOut />} />
          </Routes>
          <MainFooter />
        </div>
      </Router>
      <ToastContainer />
  </>
  );
}

export default App;
